import * as React from 'react';

export function TargetAudience() {
  return (
    <section className="gastro-audience">
      <style>{`
        .gastro-audience {
          padding: 72px 24px;
          background: #fff;
        }
        .gastro-audience-inner {
          max-width: 800px;
          margin: 0 auto;
        }
        .gastro-audience h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 36px;
          text-align: center;
        }
        .gastro-audience-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }
        .gastro-audience-col h3 {
          font-size: 16px;
          font-weight: 700;
          color: #1EAA25;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0 0 16px;
        }
        .gastro-audience-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .gastro-audience-col li {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 0;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f0f0f0;
        }
        .gastro-audience-col li:last-child {
          border-bottom: none;
        }
        .gastro-audience-col li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
          width: 20px;
          text-align: center;
        }
        @media (max-width: 640px) {
          .gastro-audience-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          .gastro-audience h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="gastro-audience-inner">
        <h2>Para quién es Abasto Virtual</h2>
        <div className="gastro-audience-grid">
          <div className="gastro-audience-col">
            <h3>Trabajamos con</h3>
            <ul>
              <li><i className="fa fa-utensils" /> Restaurantes</li>
              <li><i className="fa fa-wine-glass" /> Bares</li>
              <li><i className="fa fa-building" /> Hoteles</li>
              <li><i className="fa fa-users" /> Servicios de catering</li>
              <li><i className="fa fa-fire" /> Cocinas industriales</li>
            </ul>
          </div>
          <div className="gastro-audience-col">
            <h3>Que buscan</h3>
            <ul>
              <li><i className="fa fa-check" /> Calidad constante</li>
              <li><i className="fa fa-check" /> Entrega programada</li>
              <li><i className="fa fa-check" /> Crédito ordenado</li>
              <li><i className="fa fa-check" /> Relación a largo plazo</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
